import { SideMenuGroup } from '@v2/shared/Layouts/SideMenu';

/**
 * TopMags' institutional pages.
 *
 * Hardcoded for the same reason DiscountMags' list is: these are seven fixed pages, none
 * of them editable anywhere, and six of the seven are already spelled out in the footer —
 * a table would add a deploy-time dependency without removing one.
 *
 * DiscountMags' grouping, minus the group TopMags has no pages for: DiscountMags opens
 * with "Shop with Confidence" — guarantee, DiscountLock, reviews, payment methods — and
 * TopMags publishes none of those. What is left is Policies then Help, in DiscountMags'
 * order within each, which is also how TopMags' own footer already splits the six it lists
 * into two columns.
 *
 * "Refund Policy" is the seventh, listed although the footer does not offer it. The page is
 * real and this brand's own terms of use link to it under exactly that name.
 *
 * The labels are DiscountMags' words for the same pages — "About Us" rather than "About
 * TopMags", "FAQs" rather than "F.A.Q." — so a shopper who knows one site reads the other.
 * The hrefs are now those words too: these four had only ever been reachable as
 * `/page/<template>.html`, and they answer at the same slugs as every other brand now.
 * They come out of PageRegistry, and the server marks an entry current by comparing its
 * path against `activePath`, which that registry supplies — so a path spelled differently
 * here is not a broken link, since the old urls all 301, but it is an entry that can never
 * be highlighted.
 *
 * Paths are relative; every one of them goes through buildUrl before it is rendered.
 */
export const INSTITUTIONAL_MENU: SideMenuGroup[] = [
  {
    title: 'Policies',
    items: [
      { label: 'Refund Policy', href: '/refund-policy' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Use', href: '/terms' },
      { label: 'Accessibility', href: '/accessibility' },
    ],
  },
  {
    title: 'Help',
    items: [
      { label: 'FAQs', href: '/help' },
      { label: 'Contact Us', href: '/contact' },
      { label: 'About Us', href: '/about-us' },
    ],
  },
];
